import React, { Component } from "react";

class DowngradeForm extends Component {
	render() {
		return (
			<div className="downgradeFormWrapper">
				<div className="downgradeForm">
					<h1>Downgrade account plan</h1>
					<p>
						Are you sure you would like to downgrade{" "}
						<span>
							{
								this.props.currentProductName
							}
						</span>{" "}
						plan to{" "}
						<span>
							{
								this.props.newPlanName
							}
						</span>?
					</p>
					<p>
						All email address searches and verifications associated
						with your account will remain accessible.
					</p>
					<h4>You can always subscribe to a higher plan.</h4>
					<div className="downgradeFormButtonWrapper">
						<button className="cancelButton"
							onClick={this.props.toggleDowngradeForm}
						>
							Cancel
						</button>
						<button
							className="defaultButtonRed"
							onClick={this.props.downgrade}
						>
							Confirm
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default DowngradeForm;
